/**
 * All names animations in all currently used spine json files.
 *
 *
 * Created: 2018-11-01
 * @author jonas
 */
export class DirtyWildsSpineAnimationNames {

    //Generic symbol. Note that the generic symbol win spine uses skins!
    public static GENERIC_SYMBOL_WIN_SPINE_INITIAL_WIN:string = "initialWin";
    public static GENERIC_SYMBOL_WIN_SPINE_INDIVIDUAL_WIN:string = "individualWin";
    public static GENERIC_SYMBOL_WIN_SPINE_INDIVIDUAL_WIN_MID:string = "individualWinMid";

    //Wild symbol
    public static WILD_SYMBOL_SPINE_MULTIPLIER_ATTENTION:string = "attentionLand";
    public static WILD_SYMBOL_SPINE_COOL_DOWN:string = "cooldown";
    public static WILD_SYMBOL_SPINE_COOL_DOWN_FAST:string = "cooldown_fast";
    public static WILD_SYMBOL_SPINE_WILD_LAND:string = "wildLand";
    public static WILD_SYMBOL_SPINE_DOUBLE_CHARGE_LOOP:string = "doubleChargeLoop";
    public static WILD_SYMBOL_SPINE_DOUBLE_RELEASE:string = "doubleRelease";
    public static WILD_SYMBOL_SPINE_FIRE_LOOP:string = "fireLoop";
    public static WILD_SYMBOL_SPINE_IGNITE:string = "firespin_hit";
    public static WILD_SYMBOL_SPINE_WILD_TRANSFORM:string = "wild_transform";



    //Environment spine animations:
    //Note, all slots in spine project with the name suffix  "_tint" is tinted during respin. If they are not named with the suffix "_tint" they will not be tinted.

    //Optional, used if exists.
    public static ENV_ENTER_RESPIN:string = "enterRespin";
    public static ENV_EXIT_RESPIN:string = "exitRespin";

    //Should exist for all env spines.
    public static ENV_IDLE_LOOP:string = "idleLoop";


    //Special animation in specific ENV spines.
    public static ENV_TEMPLE_EFFECTS_HOT_ZONE_FRAME_START:string = "frameStart";
    public static ENV_TEMPLE_EFFECTS_HOT_ZONE_FRAME_END:string = "frameEnd";
    public static ENV_TEMPLE_EFFECTS_HOT_ZONE_FRAME_LOOP:string = "frameLoop";

    public static ENV_TEMPLE_HOT_ZONE_GLOW_START:string = "glowStart";
    public static ENV_TEMPLE_HOT_ZONE_GLOW_END:string = "glowEnd";
    public static ENV_TEMPLE_HOT_ZONE_GLOW_LOOP:string = "glowLoop";



    //Top bar
    public static MULTIPLIER_FIRE_SQUARE_START:string = "start";
    public static MULTIPLIER_FIRE_SQUARE_STOP:string = "stop";
    public static MULTIPLIER_FIRE_SQUARE_LOOP:string = "loop";

    public static MULTIPLIER_FIRE_SQUARE_START_GREEN:string = "startGreen";
    public static MULTIPLIER_FIRE_SQUARE_STOP_GREEN:string = "stopGreen";
    public static MULTIPLIER_FIRE_SQUARE_LOOP_GREEN:string = "loopGreen";
    public static MULTIPLIER_FIRE_SQUARE_LOOP_RED_TO_GREEN:string = "loopRedToGreen";


    public static TOP_BAR_NUMBER_FIRE_START:string = "start_respin";
    public static TOP_BAR_NUMBER_START_TEXT:string = "start_respin_text";
    public static TOP_BAR_NUMBER_FIRE_STOP:string = "stop_respin";
    public static TOP_BAR_NUMBER_TEXT_STOP:string = "stop_respin_text";
    public static TOP_BAR_NUMBER_FIRE_LOOP:string = "loop_respin";
    public static TOP_BAR_NUMBER_TEXT_LOOP:string = "loop_respin_text";

    public static TOP_BAR_MULTIPLIER_FIRE_START:string = "start";
    public static TOP_BAR_MULTIPLIER_FIRE_STOP:string = "stop";
    public static TOP_BAR_MULTIPLIER_FIRE_LOOP:string = "loop";

    public static TOP_BAR_MULTIPLIER_FIRE_START_GREEN:string = "startGreen";


    //Big win
    public static BIG_WIN_SPINE_START_SUFFIX:string = "_start";
    public static BIG_WIN_SPINE_END_SUFFIX:string = "_end";
    public static BIG_WIN_SPINE_ALL_LOOP:string = "allLoop";


}